import { combineReducers } from 'redux';
import { UPDATE_ONBOARDING_STEP, SET_STREAMS_READY } from './constants';

const onboardingInitialState = {
  onboardingTasks: [
    { step: 'connectCalendar', title: 'Connect your calendar', isCompleted: false },
    { step: 'chooseCover', title: 'Choose a cover', isCompleted: false },
    { step: 'selectHandwritingFont', title: 'Select your handwriting font', isCompleted: false },
    { step: 'placeSticker', title: 'Place a sticker', isCompleted: false },
    { step: 'createList', title: 'Create a list', isCompleted: false },
  ],
  streamsReady: false,
};

const onboardingReducer = (state = onboardingInitialState, action) => {
  switch (action.type) {
    case UPDATE_ONBOARDING_STEP:
      return {
        ...state,
        onboardingTasks: state.onboardingTasks.map(task =>
          task.step === action.payload.step
            ? { ...task, isCompleted: action.payload.isCompleted }
            : task
        ),
      };
    case SET_STREAMS_READY:
      return {
        ...state,
        streamsReady: action.payload,
      };
    default:
      return state;
  }
};

export default combineReducers({
  onboarding: onboardingReducer,
});
